var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 67.0017C134 104.008 104.003 134 67.0003 134C29.9972 134 0 104.008 0 67.0017C0 29.9975 29.9972 0 67.0003 0C104.003 0 134 29.9975 134 67.0017Z",
    fill: "#FF6D6D",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0064 49.6306C34.3692 51.8119 31.5604 58.1501 33.7368 63.7873V63.7922L43.9524 59.8461C49.5896 57.6648 52.3983 51.3267 50.2219 45.6895V45.6846L40.0064 49.6306Z",
    fill: "#FF6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9166 81.7016C67.5538 83.883 70.3626 90.2211 68.1861 95.8583V95.8632L57.9706 91.9172C52.3236 89.7358 49.5197 83.3977 51.6962 77.7605V77.7556L61.9166 81.7016Z",
    fill: "#FF6D6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8394 41.436C87.8394 31.2548 79.5896 23 69.4132 23C69.4083 23 69.4083 23 69.4034 23C69.3985 23 69.3985 23 69.3936 23C59.2173 23 50.9674 31.2548 50.9674 41.436V111",
    stroke: "#FF6D6D",
    strokeWidth: 3.48889,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4775 67.6757C66.4775 68.9423 67.5886 69.921 68.8495 69.7656C77.3876 68.7638 84.423 61.786 85.4363 53.1788C85.5284 52.4246 85.5802 51.6589 85.5802 50.8816C85.586 51.6589 85.632 52.4246 85.7241 53.1788C86.7374 61.786 93.7728 68.7581 102.311 69.7656C103.572 69.921 104.683 68.9423 104.683 67.6757V52.9197C104.735 52.2231 104.712 51.5495 104.706 50.8874C104.706 40.3343 96.1564 31.7847 85.6147 31.7847C85.609 31.7847 85.609 31.7847 85.6032 31.7847C85.5975 31.7847 85.5975 31.7847 85.5917 31.7847C75.0443 31.7847 66.5005 40.34 66.5005 50.8874C66.5811 52.2116 66.4026 66.4839 66.4775 67.6757Z",
    fill: "#FF6D6D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerError);
export default __webpack_public_path__ + "static/media/flowerError.889aebade9f4362d55970ae7622f9001.svg";
export { ForwardRef as ReactComponent };